import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=0f258b1e&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f258b1e"]])

export default __exports__